/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { getTourAppointmentClasses } from '@tours/store/tours.selectors';
import { filter, map } from 'rxjs/operators';

@Pipe({
    name: 'appointmentClassAsync',
    standalone: false
})
export class AppointmentClassAsyncPipe implements PipeTransform, OnDestroy {

  private asyncPipe: AsyncPipe;

  constructor(private store: Store<State>, private changeDetectorRef: ChangeDetectorRef) {
    this.asyncPipe = new AsyncPipe(changeDetectorRef);
  }

  transform(value: any, args?: any): any {
    return this.asyncPipe.transform(
      this.store.select(getTourAppointmentClasses).pipe(
        map(appointmentClasses  => appointmentClasses.find(appointmentClass => appointmentClass.id === value)),
        filter(appointmentClass => typeof appointmentClass !== 'undefined'),
        map(appointmentClass => appointmentClass.name)
      )
    );
  }

  ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }
}
